var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',_vm._l((_vm.inputsVisible),function(input){return _c('FormInputView',{key:input.key,attrs:{"input":input,"value":_vm.values[input.key]},on:{"input":function($event){_vm.update(input.key, $event)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }